export default "__VITE_ASSET__DKs1Ahs1__"